module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.65060723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/icons/linearicons/Linearicons-Free.woff?w118d
// module id = ./src/assets/components/icons/linearicons/Linearicons-Free.woff?w118d
// module chunks = 7